export const css = {
	root: 'gamjec45',
	' _key': 'card/micro'
};

export default css;
